"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createELKMessageLog = exports.createELKErrorLog = void 0;
var shared_1 = require("@cian/peperrors/shared");
var ExceptionData_1 = require("./ExceptionData");
function createELKErrorLog(params) {
    var level = params.level, error = params.message, _a = params.meta, meta = _a === void 0 ? {} : _a;
    var date = new Date().toISOString();
    var exceptionType = error instanceof shared_1.GenericError ? error.domain : "system-logger.unknown-domain.".concat(error.name);
    var exceptionData = error instanceof shared_1.GenericError ? Object.assign(meta, error.details) : meta;
    var exception = error.stack || "".concat(error.name || error.constructor.name, " ").concat(error.message);
    return {
        date: date,
        level: level,
        message_type: 'app',
        exception_message: error.message,
        exception: exception,
        exception_type: exceptionType,
        exception_data: (0, ExceptionData_1.convertMetaToKVCollection)(exceptionData),
    };
}
exports.createELKErrorLog = createELKErrorLog;
function createELKMessageLog(params) {
    var level = params.level, message = params.message, _a = params.meta, meta = _a === void 0 ? {} : _a;
    var date = new Date().toISOString();
    return {
        date: date,
        level: level,
        message: message,
        message_type: 'app',
        exception_data: (0, ExceptionData_1.convertMetaToKVCollection)(meta),
    };
}
exports.createELKMessageLog = createELKMessageLog;
//# sourceMappingURL=ELKLogs.js.map